export enum UserStatus {
    Active,
    Inactive,
    Disabled,
}
